app.service('productTopSeeRecommended',function(productCardConfig, callback, console, productCompare, logData, front) {
	var $self, config;

	function load() {
		var url = logData.showRecommendationsFromAWSonProductCard() ? '/user-personalized-see-also-carousel.ltr' : '/see-also-carousel.ltr';
		var data={
			productId:config.id,
			with_attributes: true
		};
		if (logData.showRecommendationsFromAWSonProductCard()) {
			data.userId = logData.customerId();
		}
		$.ajax({
			url:url,
			data:data,
			success: function(html) {
				loadSuccess(html, data);
			},
			error:function(){
				loadError(data);
			}
		});
	}
	function loadSuccess(html, data) {
		$self.addClass('loaded').html(html);
		if (front.katalog) {
			productCompare.checkCompared();
		}
		console.log('Załadowano karuzelę "zobacz także".');
		setElements();
		//$self.productSlider();  to ma wyglądać jak karuzela ale strzałka kieruje na listing
	}
	function loadError(data) {
		console.log('Błąd ładowania karuzeli "zobacz także".');
	}
	function setEvents() {
	}
	function setElements() {
		$self = $('#top-see-recommended');
	}
	function init() {
		config=productCardConfig.getData();
		setElements();
		setEvents();
		if(config.recommendationsEnabled) {
			load();
		}
	}
	return {
		init
	};
});
